import useSelectedProperty from '../../../../hooks/useSelectedProperty';

export function useOnHoldReasons() {
  const selectedProperty = useSelectedProperty();
  return selectedProperty?.config?.workOrderOnHoldReasons ?? [];
}
